import { useAtomValue } from 'jotai';
import { baseUrl, disableRevalidationForSwrOptions } from '../utils/globals';
import { useSwrData } from './swrWrapper';
import { userInfoAtom } from '../atoms/utilsAtoms';

export const useFetchActivePopUp = () => {
	const user = useAtomValue(userInfoAtom);
	const url = `${baseUrl}/popup/active`;
	const data = useSwrData(url, user?.token, disableRevalidationForSwrOptions);
	return data;
};
export const useFetchAllPopups = () => {
	const user = useAtomValue(userInfoAtom);
	const url = `${baseUrl}/popup`;
	const data = useSwrData(url, user?.token, null);
	return data;
};
export const useFetchPopupById = PopupId => {
	const user = useAtomValue(userInfoAtom);
	const url = `${baseUrl}/popup/${PopupId}`;
	const data = useSwrData(url, user?.token, null);
	
	return data;
};
